import React, { ReactElement, useEffect } from 'react';
import ReactDOM from 'react-dom';

import '@philips-emr/tws-components';
import '@philips-emr/hpms-provider-accreditation-components';
import '@philips-emr/hpms-provider-accreditation-commons';

import { HistoryService } from '@philips-emr/tws-core/lib/services';
import { Foundation } from '@philips-emr/tws-foundation';

import Audit from './configuration/audit';
import { bootstrap } from './configuration/bootstrap';

import './index.scss';
import './controllers';
import './codegen';

function RootApp(): ReactElement {
  
  useEffect(() => {
    setTimeout(() => {
      const audit = new Audit();
      void audit.routeChangeLog(HistoryService.getCurrentRoute());
      audit.addRouteListener();
    }, 100);
  });

  return (
    <Foundation
      bootstrap={bootstrap}
      root={{ fragmentName: 'root' }}
    />
  );
}

ReactDOM.render(<RootApp />, document.getElementById('root'));
